// extracted by mini-css-extract-plugin
export default {"form":"GoogleLoginForm_form__dvY2R","googleLoginButton":"GoogleLoginForm_googleLoginButton__bioKn"};